import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Fallback de segurança: se o PWA abrir na rota `/` (não deveria, pois start_url é /#/login),
 * redireciona para /login. Não mostra a landing page para usuários de PWA.
 */
export const PWALandingRouter: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches
            || (window.navigator as any).standalone === true;

        if (isStandalone) {
            navigate('/login', { replace: true });
        }
    }, [navigate]);

    return null;
};
